import { render, staticRenderFns } from "./ver_pendientes.vue?vue&type=template&id=6cd6a6ac&scoped=true"
import script from "./ver_pendientes.vue?vue&type=script&lang=js"
export * from "./ver_pendientes.vue?vue&type=script&lang=js"
import style0 from "./ver_pendientes.vue?vue&type=style&index=0&id=6cd6a6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd6a6ac",
  null
  
)

export default component.exports